export const tuitionConfigs = {
  gapan: {
    levels: [
      {
        name: "Pre-Elem to Grade 10",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 24300,
            miscFee: 11500,
            discount: 0.10,
            totalDue: 35800,
            schedule: [
              { label: "Upon Enrollment", misc: 11500, tuition: 24300, total: 35800 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 25650,
            miscFee: 11500,
            discount: 0.05,
            totalDue: 37150,
            schedule: [
              { label: "1st Sem", misc: 11500, tuition: 12825, total: 24325 },
              { label: "2nd Sem", misc: 0, tuition: 12825, total: 12825 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 27000,
            miscFee: 11500,
            discount: 0.00,
            totalDue: 38500,
            schedule: [
              { label: "Upon Enrollment", misc: 11500, tuition: 2700, total: 14200 },
              { label: "2nd Payment", tuition: 2700 },
              { label: "3rd Payment", tuition: 2700 },
              { label: "4th Payment", tuition: 2700 },
              { label: "5th Payment", tuition: 2700 },
              { label: "6th Payment", tuition: 2700 },
              { label: "7th Payment", tuition: 2700 },
              { label: "8th Payment", tuition: 2700 },
              { label: "9th Payment", tuition: 2700 },
              { label: "10th Payment", tuition: 2700 }
            ]
          }
        ]
      },
      {
    "name": "Grades 7-10 (With PEAC Subsidy/ESC I.D.)",
    "paymentModes": [
      {
        "mode": "Annual",
        "tuitionFee": 16200,
        "miscFee": 11500,
        "discount": 0.1,
        "totalDue": 27700,
        "schedule": [
          {
            "label": "Upon Enrollment",
            "misc": 11500,
            "tuition": 16200,
            "total": 27700
          }
        ]
      },
      {
        "mode": "Semestral",
        "tuitionFee": 17100,
        "miscFee": 11500,
        "discount": 0.05,
        "totalDue": 28600,
        "schedule": [
          {
            "label": "1st Sem",
            "misc": 11500,
            "tuition": 8550,
            "total": 20050
          },
          {
            "label": "2nd Sem",
            "tuition": 8550,
            "total": 8550
          }
        ]
      },
      {
        "mode": "Installment",
        "tuitionFee": 18000,
        "miscFee": 11500,
        "discount": 0,
        "totalDue": 29500,
        "schedule": [
          {
            "label": "Upon Enrollment",
            "misc": 11500,
            "tuition": 1800,
            "total": 13300
          },
          {
            "label": "2nd Payment",
            "tuition": 1800
          },
          {
            "label": "3rd Payment",
            "tuition": 1800
          },
          {
            "label": "4th Payment",
            "tuition": 1800
          },
          {
            "label": "5th Payment",
            "tuition": 1800
          },
          {
            "label": "6th Payment",
            "tuition": 1800
          },
          {
            "label": "7th Payment",
            "tuition": 1800
          },
          {
            "label": "8th Payment",
            "tuition": 1800
          },
          {
            "label": "9th Payment",
            "tuition": 1800
          },
          {
            "label": "10th Payment",
            "tuition": 1800
          }
        ]
      }
    ]
  },
      {
        name: "Incoming Senior High School from Public School",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 0, total: 0 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 0, total: 0 },
              { label: "2nd Sem", misc: 0, tuition: 0, total: 0 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "Upon Enrollment", tuition: 0 },
              { label: "2nd Payment", tuition: 0 },
              { label: "3rd Payment", tuition: 0 },
              { label: "4th Payment", tuition: 0 },
              { label: "5th Payment", tuition: 0 },
              { label: "6th Payment", tuition: 0 },
              { label: "7th Payment", tuition: 0 },
              { label: "8th Payment", tuition: 0 },
              { label: "9th Payment", tuition: 0 },
              { label: "10th Payment", tuition: 0 }
            ]
          }
        ]
      },
      {
        name: "Senior High School from Private (with voucher)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 5000, total: 5000 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 2500, total: 2500 },
              { label: "2nd Sem", misc: 0, tuition: 2500, total: 2500 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "Upon Enrollment", tuition: 500 },
              { label: "2nd Payment", tuition: 500 },
              { label: "3rd Payment", tuition: 500 },
              { label: "4th Payment", tuition: 500 },
              { label: "5th Payment", tuition: 500 },
              { label: "6th Payment", tuition: 500 },
              { label: "7th Payment", tuition: 500 },
              { label: "8th Payment", tuition: 500 },
              { label: "9th Payment", tuition: 500 },
              { label: "10th Payment", tuition: 500 }
            ]
          }
        ]
      },
      {
        name: "Senior High School (no voucher)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 19500, total: 19500 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 9750, total: 9750 },
              { label: "2nd Sem", misc: 0, tuition: 9750, total: 9750 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "Upon Enrollment", tuition: 1950 },
              { label: "2nd Payment", tuition: 1950 },
              { label: "3rd Payment", tuition: 1950 },
              { label: "4th Payment", tuition: 1950 },
              { label: "5th Payment", tuition: 1950 },
              { label: "6th Payment", tuition: 1950 },
              { label: "7th Payment", tuition: 1950 },
              { label: "8th Payment", tuition: 1950 },
              { label: "9th Payment", tuition: 1950 },
              { label: "10th Payment", tuition: 1950 }
            ]
          }
        ]
      }
    ]
  },
  bulacan: {
    levels: [
      {
        name: "Pre-elementary (Nursery-Kinder)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 25200,
            miscFee: 8000,
            discount: 0.10,
            totalDue: 33200,
            schedule: [
              { label: "Upon Enrollment", misc: 8000, tuition: 25200, total: 33200 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 13300,
            miscFee: 8000,
            discount: 0.05,
            totalDue: 34600,
            schedule: [
              { label: "1st Sem (Upon Enrollment)", misc: 8000, tuition: 13300, total: 21300 },
              { label: "2nd Sem (Nov)", misc: 0, tuition: 13300, total: 13300 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 25200,
            miscFee: 8000,
            discount: 0.00,
            totalDue: 36000,
            schedule: [
              { label: "Upon Enrollment (June)", misc: 8000, tuition: 2800, total: 10800 },
              { label: "July", tuition: 2800 },
              { label: "August", tuition: 2800 },
              { label: "September", tuition: 2800 },
              { label: "October", tuition: 2800 },
              { label: "November", tuition: 2800 },
              { label: "December", tuition: 2800 },
              { label: "January", tuition: 2800 },
              { label: "February", tuition: 2800 },
              { label: "March", tuition: 2800 }
            ]
          }
        ]
      },
      {
        name: "Grades 1-3",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 25470,
            miscFee: 8200,
            discount: 0.10,
            totalDue: 33670,
            schedule: [
              { label: "Upon Enrollment", misc: 8200, tuition: 25470, total: 33670 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 13442.5,
            miscFee: 8200,
            discount: 0.05,
            totalDue: 35085,
            schedule: [
              { label: "1st Sem (Upon Enrollment)", misc: 8200, tuition: 13442.5, total: 21642.5 },
              { label: "2nd Sem (Nov)", misc: 0, tuition: 13442.5, total: 13442.5 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 25470,
            miscFee: 8200,
            discount: 0.00,
            totalDue: 36500,
            schedule: [
              { label: "Upon Enrollment (June)", misc: 8200, tuition: 2830, total: 11030 },
              { label: "July", tuition: 2830 },
              { label: "August", tuition: 2830 },
              { label: "September", tuition: 2830 },
              { label: "October", tuition: 2830 },
              { label: "November", tuition: 2830 },
              { label: "December", tuition: 2830 },
              { label: "January", tuition: 2830 },
              { label: "February", tuition: 2830 },
              { label: "March", tuition: 2830 }
            ]
          }
        ]
      },
      {
        name: "Grades 4-5",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 25380,
            miscFee: 8300,
            discount: 0.10,
            totalDue: 33680,
            schedule: [
              { label: "Upon Enrollment", misc: 8300, tuition: 25380, total: 33680 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 13395,
            miscFee: 8300,
            discount: 0.05,
            totalDue: 35090,
            schedule: [
              { label: "1st Sem (Upon Enrollment)", misc: 8300, tuition: 13395, total: 21695 },
              { label: "2nd Sem (Nov)", misc: 0, tuition: 13395, total: 13395 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 25380,
            miscFee: 8300,
            discount: 0.00,
            totalDue: 36500,
            schedule: [
              { label: "Upon Enrollment (June)", misc: 8300, tuition: 2820, total: 11120 },
              { label: "July", tuition: 2820 },
              { label: "August", tuition: 2820 },
              { label: "September", tuition: 2820 },
              { label: "October", tuition: 2820 },
              { label: "November", tuition: 2820 },
              { label: "December", tuition: 2820 },
              { label: "January", tuition: 2820 },
              { label: "February", tuition: 2820 },
              { label: "March", tuition: 2820 }
            ]
          }
        ]
      },
      {
        name: "Grades 6-10 (Regular)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 25830,
            miscFee: 8600,
            discount: 0.10,
            totalDue: 34430,
            schedule: [
              { label: "Upon Enrollment", misc: 8600, tuition: 25830, total: 34430 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 13632.5,
            miscFee: 8600,
            discount: 0.05,
            totalDue: 35865,
            schedule: [
              { label: "1st Sem (Upon Enrollment)", misc: 8600, tuition: 13632.5, total: 22232.5 },
              { label: "2nd Sem (Nov)", misc: 0, tuition: 13632.5, total: 13632.5 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 25830,
            miscFee: 8600,
            discount: 0.00,
            totalDue: 37300,
            schedule: [
              { label: "Upon Enrollment (June)", misc: 8600, tuition: 2870, total: 11470 },
              { label: "July", tuition: 2870 },
              { label: "August", tuition: 2870 },
              { label: "September", tuition: 2870 },
              { label: "October", tuition: 2870 },
              { label: "November", tuition: 2870 },
              { label: "December", tuition: 2870 },
              { label: "January", tuition: 2870 },
              { label: "February", tuition: 2870 },
              { label: "March", tuition: 2870 }
            ]
          }
        ]
      },
      {
        name: "Pre-Elem to Grade 6",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 22050,
            miscFee: 11500,
            discount: 0.10,
            totalDue: 33550,
            schedule: [
              { label: "Upon Enrollment", misc: 11500, tuition: 22050, total: 33550 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 23275,
            miscFee: 11500,
            discount: 0.05,
            totalDue: 34775,
            schedule: [
              { label: "1st Sem", misc: 6000, tuition: 11638, total: 17638 },
              { label: "2nd Sem", misc: 5500, tuition: 11637, total: 17137 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 24500,
            miscFee: 11500,
            discount: 0.00,
            totalDue: 36000,
            schedule: [
              { label: "Upon Enrollment", misc: 6000, tuition: 2450, total: 8450 },
              { label: "2nd Payment", tuition: 2450 },
              { label: "3rd Payment", tuition: 2450 },
              { label: "4th Payment", tuition: 2450 },
              { label: "5th Payment", misc: 5500, tuition: 2450, total: 7950 },
              { label: "6th Payment", tuition: 2450 },
              { label: "7th Payment", tuition: 2450 },
              { label: "8th Payment", tuition: 2450 },
              { label: "9th Payment", tuition: 2450 },
              { label: "10th Payment", tuition: 2450 }
            ]
          }
        ]
      },
      {
        name: "Grades 7-10 (With PEAC Subsidy/ESC I.D.)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 17730,
            miscFee: 8600,
            discount: 0.10,
            totalDue: 26330,
            schedule: [
              { label: "Upon Enrollment", misc: 8600, tuition: 17730, total: 26330 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 9357.5,
            miscFee: 8600,
            discount: 0.05,
            totalDue: 27315,
            schedule: [
              { label: "1st Sem (Upon Enrollment)", misc: 8600, tuition: 9357.5, total: 17957.5 },
              { label: "2nd Sem (Nov)", misc: 0, tuition: 9357.5, total: 9357.5 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 17730,
            miscFee: 8600,
            discount: 0.00,
            totalDue: 28300,
            schedule: [
              { label: "Upon Enrollment (June)", misc: 8600, tuition: 1970, total: 10570 },
              { label: "July", tuition: 1970 },
              { label: "August", tuition: 1970 },
              { label: "September", tuition: 1970 },
              { label: "October", tuition: 1970 },
              { label: "November", tuition: 1970 },
              { label: "December", tuition: 1970 },
              { label: "January", tuition: 1970 },
              { label: "February", tuition: 1970 },
              { label: "March", tuition: 1970 }
            ]
          }
        ]
      },
      {
        name: "Incoming Senior High School from Public School",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 0, total: 0 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 0, total: 0 },
              { label: "2nd Sem", misc: 0, tuition: 0, total: 0 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 0,
            miscFee: 0,
            discount: 0.00,
            totalDue: 0,
            schedule: [
              { label: "Upon Enrollment", tuition: 0 },
              { label: "2nd Payment", tuition: 0 },
              { label: "3rd Payment", tuition: 0 },
              { label: "4th Payment", tuition: 0 },
              { label: "5th Payment", tuition: 0 },
              { label: "6th Payment", tuition: 0 },
              { label: "7th Payment", tuition: 0 },
              { label: "8th Payment", tuition: 0 },
              { label: "9th Payment", tuition: 0 },
              { label: "10th Payment", tuition: 0 }
            ]
          }
        ]
      },
      {
        name: "Senior High School from Private (with voucher)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 5000, total: 5000 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 2500, total: 2500 },
              { label: "2nd Sem", misc: 0, tuition: 2500, total: 2500 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 5000,
            miscFee: 0,
            discount: 0.00,
            totalDue: 5000,
            schedule: [
              { label: "Upon Enrollment", tuition: 500 },
              { label: "2nd Payment", tuition: 500 },
              { label: "3rd Payment", tuition: 500 },
              { label: "4th Payment", tuition: 500 },
              { label: "5th Payment", tuition: 500 },
              { label: "6th Payment", tuition: 500 },
              { label: "7th Payment", tuition: 500 },
              { label: "8th Payment", tuition: 500 },
              { label: "9th Payment", tuition: 500 },
              { label: "10th Payment", tuition: 500 }
            ]
          }
        ]
      },
      {
        name: "Senior High School (no voucher)",
        paymentModes: [
          {
            mode: "Annual",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "Upon Enrollment", misc: 0, tuition: 19500, total: 19500 }
            ]
          },
          {
            mode: "Semestral",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "1st Sem", misc: 0, tuition: 9750, total: 9750 },
              { label: "2nd Sem", misc: 0, tuition: 9750, total: 9750 }
            ]
          },
          {
            mode: "Installment",
            tuitionFee: 19500,
            miscFee: 0,
            discount: 0.00,
            totalDue: 19500,
            schedule: [
              { label: "Upon Enrollment", tuition: 1950 },
              { label: "2nd Payment", tuition: 1950 },
              { label: "3rd Payment", tuition: 1950 },
              { label: "4th Payment", tuition: 1950 },
              { label: "5th Payment", tuition: 1950 },
              { label: "6th Payment", tuition: 1950 },
              { label: "7th Payment", tuition: 1950 },
              { label: "8th Payment", tuition: 1950 },
              { label: "9th Payment", tuition: 1950 },
              { label: "10th Payment", tuition: 1950 }
            ]
          }
        ]
      }
    ]
  }
};

function getCachedPricingLevels(campus) {
  try {
    const raw = localStorage.getItem(`gradePricing_cache_${String(campus).toLowerCase()}`);
    const data = raw ? JSON.parse(raw) : null;
    if (data && Array.isArray(data.levels)) return data.levels;
  } catch {
    /* ignore */
  }
  return (tuitionConfigs[String(campus).toLowerCase()]?.levels) || [];
}

// Utility function to get payment schedule for a student (Firestore override-aware)
export function getStudentPaymentSchedule({ campus, levelName, paymentMode, customDiscount = null }) {
  const levels = getCachedPricingLevels(campus);
  const level = levels.find(l => l.name === levelName);
  if (!level) return null;

  const mode = level.paymentModes.find(m => m.mode === paymentMode);
  if (!mode) return null;

  const baseTuition = Number(mode.tuitionFee || 0);
  const baseMisc = Number(mode.miscFee || 0);
  const hasCustom = customDiscount !== null && customDiscount !== undefined;
  const disc = hasCustom ? Number(customDiscount) : null;
  const tuitionAdj = hasCustom ? baseTuition * (1 - disc) : baseTuition;
  const totalDue = hasCustom ? tuitionAdj + baseMisc : Number(mode.totalDue || (baseTuition + baseMisc));
  const schedule = (mode.schedule || []).map(s => {
    const tu = Number(s.tuition || 0);
    const mi = Number(s.misc || 0);
    const adjTu = hasCustom ? tu * (1 - disc) : tu;
    const tot = mi + adjTu;
    return { ...s, tuition: adjTu, misc: mi, total: tot };
  });

  return {
    tuitionFee: tuitionAdj,
    miscFee: baseMisc,
    totalDue,
    schedule,
  };
}
